import primaryComponents from "../../../primaryComponents";
import Validation from "./Validation";
import useInventoryAccountSettings from "./useInventoryAccountSettings";
import styles from "../../../../pages/appPages/Accounting/AccountSettings/styles.module.scss";

const InventoryAccountSettings = ({
  filterAccountBySubAccountType,
  findAccountMapping,
  updateAccountMappingMutation,
  handleAccountMappingSubmit,
}) => {
  const { inventoryAccountMapping, setInventoryAccountMapping } =
    useInventoryAccountSettings(findAccountMapping);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = Validation({ inventoryAccountMapping });
  return (
    <form className="p-3" onSubmit={handleSubmit(handleAccountMappingSubmit)}>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Inventory Asset Account</h5>
          <span>
            The account used to track the value of stock currently held.
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("inventory")}
            control={control}
            name="inventory_asset_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("inventory_asset_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setInventoryAccountMapping((prev) => ({
                ...prev,
                inventory_asset_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.inventory_asset_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Cost of Goods Sold (COGS) Account</h5>
          <span>
            Expense account where the cost of sold inventory items is recorded
            when a sale is made
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("cost_of_goods_sold")}
            control={control}
            name="cost_of_goods_sold_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("cost_of_goods_sold_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setInventoryAccountMapping((prev) => ({
                ...prev,
                cost_of_goods_sold_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.cost_of_goods_sold_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Stock Adjustment / Lost Account</h5>
          <span>
            Account for inventory shrinkage, losses, or adjustments due to
            damage or theft
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("operating_expenses")}
            control={control}
            name="stock_adjustment_lost_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("stock_adjustment_lost_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setInventoryAccountMapping((prev) => ({
                ...prev,
                stock_adjustment_lost_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.stock_adjustment_lost_account}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          type="submit"
          isDisabled={updateAccountMappingMutation.isLoading}
          isLoading={updateAccountMappingMutation.isLoading}
          loadingText={"Updating..."}
        >
          Save Changes
        </primaryComponents.Button>
      </div>
    </form>
  );
};
export default InventoryAccountSettings;
